import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/ar';
import resources from './locales';

// keep moment date formatting (fromNow, month names) in sync with the app language
moment.locale('en');
i18n.on('languageChanged', lng => moment.locale(lng || 'en'));

const languageDetector = new LanguageDetector(null, {
  order: ['localStorage', 'cookie', 'sessionStorage', 'navigator'],

  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupSessionStorage: 'i18nextLng',
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false,
    },
  });

moment.locale(i18n.language || 'en');

export default i18n;
